import axios from "axios";
require("dotenv").config({ path: __dirname + "/./../../.env" });

const api = axios.create({
    baseURL:
        process.env.REACT_APP_BACKEND_VENDAS_IP ||
        "https://vendasapi.capys.com.br",
});

api.interceptors.request.use((config) => {
    if (localStorage.getItem("@token"))
        config.headers.Authorization = `Bearer ${localStorage.getItem(
            "@token"
        )}`;

    return config;
});

// para sugerir na hora de importar, já que usamos Axios como padrão
const AxiosVendas = api;
export default AxiosVendas;
